import wretch from 'wretch';

import { CoreRestErrorHandler } from '../../../../service/coreCommon/common/rest/CoreRestErrorHandler';
import { CoreRestService } from '../../../../service/coreCommon/common/rest/CoreRestService';
import { IProjectModel } from '../../../../service/project/IProjectModel';
import { IUserSystemRoleModel } from '../../../../service/systemRole/entity/IUserSystemRoleModel';
import { IUserEntityModel } from '../../../../service/user/IUserEntityModel';
import { ILearningConfig } from '../../application/config/ILearningConfig';
import { LearningEnvConfigManager } from '../../application/config/LearningEnvConfigManager';
import { ILearningReportService } from './ILearningReportService';
import { IGetUserLearningDataByProjectArg, IGetUserLearningDataByProjectRes } from './interface/IGetUserLearningDataByProject';
import { IProjectLearningReportArg } from './interface/IProjectLearningReportArg';
import { IProjectLearningReportModel } from './interface/IProjectLearningReportModel';

wretch().errorType('json');

export class RestLearningReportService  extends CoreRestService implements ILearningReportService {
  constructor(
    protected config: ILearningConfig = LearningEnvConfigManager.getConfig(),
    protected errorHandler = new CoreRestErrorHandler(),
  ) {
    super();
  }
  getProjectStat(arg: IProjectLearningReportArg = {}): Promise<IProjectLearningReportModel[]> {
    return super.post(`${this.getEndpoint()}/learning/getProjectStat`, arg)
  }

  async generateProjectUnitSummuryByUsers(userList:IUserEntityModel[],systemRoles:IUserSystemRoleModel[],projects:IProjectModel[],unitSummuryTemplatePath?:string): Promise<any> {
    const url = `${this.getEndpoint()}/learning/docx`;

    const doc = await this.post(url,{
      userList:userList,
      systemRoles:systemRoles,
      projects:projects,
      unitSummuryTemplatePath:unitSummuryTemplatePath

    })


    const blobDoc = await doc.blob();
    return blobDoc;
  }
  async generateProjectUnitSummuryByUsersPdf(userList:IUserEntityModel[],systemRoles:IUserSystemRoleModel[],projects:IProjectModel[],unitSummuryTemplatePath?:string): Promise<any> {
    const url = `${this.getEndpoint()}/learning/pdf`;

    const doc = await this.post(url,{
      userList:userList,
      systemRoles:systemRoles,
      projects:projects,
      unitSummuryTemplatePath:unitSummuryTemplatePath
    })

    const blobDoc = await doc.blob();
    return blobDoc;
  }
  getEndpoint(): string {
    const url = this.config.url.api.learning;
    return `${url}/report`;
  }

  async post(url: string, data: any): Promise<any> {
    return this.request().url(url).post(data);
  }

  async getUserLearningDataByProject({ type }: IGetUserLearningDataByProjectArg): Promise<IGetUserLearningDataByProjectRes> {
    const url = `${this.getEndpoint()}/learning/getUserLearningDataByProject/${type}`;

    const doc = await this.request().url(url).post();

    const blobDoc = await doc.blob()

    return blobDoc;
  }
}
